<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('podcast-episode', true)">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Add New Podcast</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="mb-4">
          <p class="input-title text-black">Title</p>
          <base-input
            alternative
            class="mb-3"
            name="Title"
            :rules="{ required: true }"
            placeholder="Title"
            v-model="title"
            maxlength="200"
          >
          </base-input>
        </div>

        <div class="mb-4">
          <p class="input-title text-black">
            Podcast Ep URL (Add an embedded link)
          </p>
          <base-input
            alternative
            class="mb-3"
            name="Podcast URL"
            :rules="{
              required: true,
              regex:
                /\b((?:https?|http):\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)\b/,
            }"
            placeholder="ex: https://creators.spotify.com/"
            v-model="link"
          >
          </base-input>
        </div>
        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 700 × 500px
        </div>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />

        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
        <img v-if="image" :src="image" ref="cover" />

        <!-- <div>
          <p class="input-title text-black">Description</p>
          <base-input
            alternative
            class="mb-3"
            name="Description"
            :rules="{ required: true }"
            placeholder="Description"
            v-model="description"
            maxlength="1000"
          >
          </base-input>
        </div> -->
        <b-form-group label="Description">
          <quill-editor
            v-model="description"
            :options="editorOption"
            class="quill-h200px my-2"
          />
        </b-form-group>
        <base-button
          type="primary"
          outline
          class="w-full my-2 py-1"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "./components/FileUploader.vue";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      title: "",
      link: "",
      image: null,
      coverImage: null,
      description: "",
      editorOption: {
        theme: "snow",
      },
      imageErr: false,
      msg: {},
    };
  },
  computed: {
    ...mapState("podcast", { getAllCategory: "getAllCategory" }),
  },
  methods: {
    handleSuccess(image) {
      console.log(image);

      this.imageErr = false;

      if (!image.type.startsWith("image/")) {
        this.$swal.fire({
          title: "Invalid File",
          text: "Please upload an image file only!",
          // html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          icon: "error",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          text: "Please ensure that the file size does not exceed 5MB",
          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      this.coverImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      // let payload = {
      //   link: this.link,
      //   title: this.title,
      //   description: this.description,
      //   podcastId: this.$route.query.pid,
      //   categoryId: this.$route.query.cid,
      // };
      let FormData = require("form-data");
      let data = new FormData();
      data.append("title", this.title);
      data.append("image", this.coverImage);
      if (this.description) data.append("description", this.description);
      if (!this.description) {
        this.$notify.error({
          message: "Description is required",
          position: "top-right",
        });
        return;
      }
      data.append("link", this.link);

      data.append("podcastId", this.$route.query.pid);
      data.append("categoryId", this.$route.query.cid);

      let loader = this.$loading();
      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image or Upload SVG Image only",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }
      try {
        const blogdata = await this.$store.dispatch(
          "podcast/add_episode",
          data
        );
        // if (blogdata.code == 200) {
        this.$router.push({
          name: "podcast-episode",
          query: {
            pid: this.$route.query.pid,
            cid: this.$route.query.cid,
          },
        });
        this.$swal.fire({
          title: "Congratulations!",
          text: "Your podcast has been successfully added",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        // }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },

    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name, query = false) {
      if (query) {
        this.$router.push({
          name: name,
          query: {
            pid: this.$route.query.pid,
            cid: this.$route.query.cid,
          },
        });
      } else {
        this.$router.push({ name: name });
      }
    },
  },
  mounted() {},
};
</script>
